<template>
  <section>
    <div v-if="obj" class="basic2">
      <div class="basic2-title">
        <span>
          <el-avatar
            :size="66"
            :src="obj.cover_pic"
            class="elAvatar"
          />
        </span>
        <span>{{ obj.name }}</span>
        <span>
          <el-button
            v-if="obj.is_collection == 1"
            class="btn1"
            @click="handleControl('edit')"
          >
            <i class="el-icon-edit" />
            编辑
          </el-button>
          <el-button v-else class="btn1" @click="handleControl('evaluate')">
            <i class="el-icon-plus" />
            收藏
          </el-button>
          <el-button
            v-if="obj.design_pano_url_ai"
            class="btn2"
            @click="handleControl('roam')"
          >
            <i class="el-icon-edit" />
            漫游
          </el-button>
        </span>
        <span>收藏后可以编辑</span>
      </div>
      <div class="basic2-content">
        <div class="basic2-tag">
          <div>空间面积：{{ obj.src_area }}㎡</div>
          <div>容纳人数：{{ obj.galleryful }}人</div>
          <div>学段：{{ obj.category_p_name }}</div>
          <div>设计理念：</div>
        </div>
        <div class="basic2-btn">
          <el-tooltip class="item" effect="light" :content="obj.philosophy" placement="top">
            <div>
              {{ obj.philosophy }}
            </div>
          </el-tooltip>

          <div>
            <!-- <img :src="require(`@/assets/icon/icon-start3.png`)" alt=""> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoBasic2',
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleControl(v) {
      this.$emit('control', v)
    }
  }
}
</script>

<style scoped lang="scss">
.basic2 {
  height: 100%;
  padding-left: 24px;
  position: relative;
  &-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    > span {
      &:nth-child(1) {
        margin-bottom: 14px;
      }
      &:nth-child(2) {
        margin-bottom: 14px;
        font-size: 18px;
        color: #333;
        font-weight: bolder;
      }
      &:nth-child(3) {
        margin-bottom: 4px;
        .btn1 {
          @include fun-btn(2);
        }
        .btn2 {
          @extend .btn1;
          background-color: #f5b429;
        }
      }
      &:nth-child(4) {
        margin-bottom: 26px;
        @include fun-design(5);
      }
    }
  }
  &-tag {
    overflow: hidden;
    > div {
      margin-bottom: 4px;
      @include fun-design(5);
    }
  }
  &-btn {
    position: relative;
    > div {
      &:nth-child(1) {
        width: 340px;
        @include fun-design(5);
        line-height: 29px;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
      &:nth-child(2) {
        position: absolute;
        top: 6px;
        left: 0;
      }
    }
  }
}
</style>
